module.exports = __webpack_public_path__ + "media/images/icon_crown01-6894e08c0b3537a7fcd7a8146bc73b35.png";